<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="供应商名称"><el-input size="small" v-model="searchForm.supply_name" placeholder="请输入供应商名称"></el-input></el-form-item>
       
        <el-form-item label="产品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
        <!-- <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="门店列表">
          <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="物流中心" v-if="is_open_logistics">
          <el-select size="small" v-model="searchForm.logistics_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.name" :value="item.logistics_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
         <el-form-item label="导出方式">
          <el-select size="small" v-model="searchForm.export_type" placeholder="请选择">
            <el-option label="按订单" value=""></el-option>
            <el-option label="按产品" value="1"></el-option>
            <el-option label="按统计" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item style="float: right;">
          <el-button size="small" type="warning" @click="showBatchDelivery" 
          v-auth="'/order/order/operate/batchDelivery'">批量发货</el-button>
        </el-form-item> -->

        <!-- <el-form-item label="门店名称">
          <el-input size="small" v-model="searchForm.store_name" placeholder="请输入门店名称"></el-input>
        </el-form-item> -->

        <el-form-item label="客户名称/手机号">
          <el-input size="small" v-model="searchForm.user_name" placeholder="请输入客户名称/手机号"></el-input>
        </el-form-item>
      
        <!-- <el-form-item label="业务员名称/手机号">
          <el-input size="small" v-model="searchForm.saler_name" placeholder="请输入业务员名称/手机号"></el-input>
        </el-form-item> -->
      

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" 
          @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport"  
          v-auth="'/order/order/operate/export'">导出全部</el-button></el-form-item>

          <!-- <el-form-item><el-button size="small" type="success" @click="batchExport"  
            v-auth="'/order/order/operate/exportSelect'">批量导出</el-button></el-form-item> -->


        <el-form-item><el-button size="small" type="primary" @click="importOrder"  v-auth="'/order/order/operate/import'">导入</el-button></el-form-item>
        <!--  -->
        <el-form-item><el-button size="small" type="primary" 
           v-auth="'/order/order/generatedeliverynote'"
         
          @click="generateDeliveryNote"  

             style="background: #7f68ff;border: 1px solid  #7f68ff;"
          >生成发货单</el-button></el-form-item>


          <!-- <el-form-item><el-button size="small" 
            
            v-auth="'/order/order/generatedeliverynotefixedline'"
            type="primary" @click="generateDeliveryNoteByLine"  

           style="background: #ffd800;border: 1px solid  #ffd800;"
          >通过线路生成发货单</el-button></el-form-item> -->



          <el-form-item><el-button size="small" 
            
       
            type="primary" @click="getToday(1)"  
             v-auth="'/order/order/index/today'"
    style="background: #ff502d;border: 1px solid  #ff502d;"
             
          >获取今天订单</el-button></el-form-item>

          <el-form-item><el-button size="small" 
            
       
            type="primary" @click="getToday(2)"  
             v-auth="'/order/order/index/today'"

       
                    style="background: #3cb7e0;border: 1px solid  #3cb7e0;"
          >获取今天未发货订单</el-button></el-form-item>



          <!-- <el-form-item><el-button size="small" 
            
       
            type="primary" @click="dorder"  
            v-auth="'/order/order/index/ddxd'"

               style="background: #46e008;border: 1px solid  #46e008;"
          >代店下单</el-button></el-form-item> -->
   


          
          <el-form-item><el-button size="small" 
            
       
            type="primary" @click="open_driver = true"  
             v-auth="'/order/order/index/choosedriver'"
                   style="background: #ff8c00;border: 1px solid  #ff8c00;"
          >选择司机</el-button></el-form-item>

          <driver v-if="open_driver" :open_driver="open_driver" @choose1="close_driver"></driver>    




      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="all">
            <template slot="label">
              <div class="tab-label">
                全部订单
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane name="payment">
            <template slot="label">
              <div class="tab-label">
                未付款
              </div>
            </template>
          </el-tab-pane>
          
          <!-- (' + order_count.payment + ') -->
          <el-tab-pane name="delivery">
            <template slot="label">
              <div class="tab-label">
                待派单
              </div>
            </template>
          </el-tab-pane>
          
          <!-- (' + order_count.delivery + ') -->
          <el-tab-pane name="received">
            <template slot="label">
              <div class="tab-label">
                待收货/已发货
              </div>
            </template>
          </el-tab-pane>
          <!-- (' + order_count.received + ') -->
          <el-tab-pane name="comment">
            <template slot="label">
              <div class="tab-label">
                待评价
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane name="six">
            <template slot="label">
              <div class="tab-label">
                已完成
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane name="canceling">
            <template slot="label">
              <div class="tab-label">
                取消订单
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane name="cancel">
            <template slot="label">
              <div class="tab-label">
                已取消
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" 
        @selection-change="tableCurrentChange"    ref="multipleTable" @select-all="selectAll"
        
        border style="width: 100%" v-loading="loading">

   <el-table-column type="selection" width="45"></el-table-column>

    
          <el-table-column prop="pay_price" label="实付款" width="70">
            <template slot-scope="scope" >

              <div> <div class="orange">{{ scope.row.pay_price }}</div>
              <!-- <p class="gray9">(含运费：{{ scope.row.express_price }})</p> -->
            </div>


             
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家"  width="220">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
            </template>
          </el-table-column>

     
<!-- 
          <el-table-column prop="supplys.name" label="商家">
          </el-table-column>
 -->

<!-- 
          <el-table-column prop="extractStore.store_name" label="下单门店"  width="220">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <span style="color: crimson;">  {{ scope.row.extractStore.store_name }}</span>
            </template>
          </el-table-column> -->

          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
            {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user?scope.row.user.mobile:''}}</span>
              <br />
              <span v-if="scope.row.reserve_date||scope.row.reserve_time">预约时间:{{scope.row.reserve_date?scope.row.reserve_date:''}} {{scope.row.reserve_time?scope.row.reserve_time:''}}</span>
            </template>
          </el-table-column>
  
              
          <el-table-column prop="supply.name" label="发货供应商" width="150">
          </el-table-column>
         


          <el-table-column prop="" label="配送司机" width="170">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.driver?scope.row.driver.nickName:'' }} <span class="gray9" v-if="scope.row.driver && scope.row.driver.mobile">({{ scope.row.driver? scope.row.driver.mobile:'' }})</span></div>
             
            </template>
          </el-table-column> 
          <el-table-column prop="driver.status_text" label="配送状态">
          </el-table-column>

          <el-table-column prop="driver.ps_time" label="配送完成时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button v-if="(supply_id>0&&supply_setting.order_detail>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
              <!-- <el-button
                v-if="(scope.row.pay_type.value == 140) && (scope.row.pay_status.value == 10 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value == 10
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="payClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/sure_off_pay'"
              >
                确认线下支付
              </el-button>
              <el-button
                v-if="(scope.row.pay_type.value == 110) && (scope.row.pay_status.value == 10 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value == 10
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                确认支付
              </el-button> -->
              
              
              <!-- <el-button
                v-if="(scope.row.pay_type.value == 110) && (scope.row.pay_status.value == 10 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value == 10
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                确认支付
              </el-button> -->



  
               <!-- <el-button
               v-if=" scope.row.delivery_type.value != 60 && scope.row.order_type == 10 && scope.row.pay_status.value == 10 
          && scope.row.order_status.value == 10 
          && (scope.row.order_source == 10 || scope.row.order_source == 50  || scope.row.order_source == 90) && scope.row.delivery_status.value == 10"
                @click="editClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
              确认运费
              </el-button> -->
        
              <el-button
                v-if="scope.row.delivery_type.value != 60 &&scope.row.pay_status.value == 20 && scope.row.order_type ==10 && (scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                去发货
              </el-button>
              <el-button
                v-if="scope.row.delivery_type.value != 60 &&   (scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 20)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/operate/extract'"
              >
                去核销
              </el-button>
              <el-button v-if="scope.row.order_status.value == 21&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/operate/confirmCancel'">去审核</el-button>
            
              <el-button  @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/order/order/delete'">删除</el-button>
              <!-- <el-button v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
              @click="selectForm(scope.row)" type="text"
              size="small" >选择销售单</el-button> -->
              <el-button v-if="(scope.row.pay_status.value == 20 && scope.row.print_temp_id>0 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
              @click="printClick(scope.row)" type="text"
              size="small" v-auth="'/order/order/genorder'">打印销售单</el-button>
            </template>
          </el-table-column>
    
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
      <div>1、先按未发货条件筛选后，导出订单</div>
      <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
      <div>3、请检查物流公司是否已经添加到系统，<el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
      </div>
      <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
        <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="uploadImage" :show-file-list="false">
          <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
        </el-upload>
      </div>
    </el-dialog>

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

    <Add v-if="open_edit" :open_edit="open_edit" :order_id="order_id"  @close="closeDialogFunc($event, 'edit')"></Add>

    <Lines v-if="open_line" :is_open="open_line" :selectlist="[]" :multi="false"  
    @closex="closeDialogLine($event)"></Lines>

    <AddOM :open_add="open_add" v-if="open_add" :type="3"  @close="closeAdd"></AddOM>

    <Pay :open_add="open_pay" :order_id="order_id"  v-if="open_pay"   @close="closePay"></Pay>
    <SelectForm v-if="open_form" :open_form="open_form" :order_id="order_id" :FormList="FormList" @closeDialog="closeDialogFunc($event, 'select_form')"></SelectForm>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import driver from './driver.vue';
import Upload from '@/components/file/import'
import qs from 'qs'
import clip from '@/utils/clipboard'
import Add from './dialog/Add.vue';
import Lines from '@/components/select/line.vue';
import Pay from './dialog/pay.vue';
import AddOM from '../../plus/out_management/index/part/add.vue';
import SelectForm from './SelectForm.vue';
export default {
  components:{
    Upload,
    Add,
    Lines,
    AddOM,
    driver,
    Pay,
    SelectForm
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        product_name:"",
        export_type:'',
        order_no: '',
        style_id: '',
        store_id: '',
        create_time: '',
        supply_name:"",
        driver_id:0,
        // store_name:"",
        user_name:"",
        saler_name:""
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /* 物流中心 */
      logisticsList:[],
      /* 是否开启物流中心 */
      is_open_logistics:false,
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      supply_id:0,
      supply:{},
       open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,


      multipleSelection:[],

         /*是否打开编辑弹窗*/
         open_edit: false,
         open_form:false,
         order_id:0,


         open_line:false,

         open_add:false,
         open_driver:false,
         open_pay:false,
    };
  },
  created() {
    if (this.$route.query.saler_name != null) {
        this.searchForm.saler_name = this.$route.query.saler_name;
      }
    /*获取列表*/
    this.getData();
    this.getFormList();
  },
  methods: {
    getFormList(){
      let self = this;
        OrderApi.getFormList({
          supply_id:self.searchForm.supply_id
        }, true)
        .then(data => {
          self.loading = false;
          self.FormList = data.data;
          console.log(self.FormList,'self.FormList')
        })
        .catch(error => {
          self.loading = false;
        });
    },
    printClick(item){
        this.$router.push({
            path: '/order/order/genorder',
            query: {
              id: item.order_id,
              print_temp_id:item.print_temp_id
            }
        });
    },
    payClick(row){
      this.order_id = row.order_id;
        this.open_pay = true;
    },
    closePay(){
        this.open_pay = false;
        this.getData();
    },
    dorder(){
      let self = this;
      this.open_add=true;
    },
    close_driver(item){
      this.searchForm.driver_id = item.id;
      this.open_driver=false;
      if(item.id>0){
        this.getDriverOrder();
      }else{
         this.getData();
      }
    },
    /*关闭添加*/
   closeAdd(e){
      this.open_add=false;
      this.getData();
    },
    toggleAllSelection() {
      var self = this;
      // 步骤1：清空当前所有选中项
      this.$refs.multipleTable.clearSelection();
      
      // 步骤2：筛选需要选中的行（示例：选中ID为1和3的行）
      const targetIds = [];

      for(var i=0;i<self.tableData.data.length;i++){
        if(self.tableData.data[i].state_text == "待派单"){
          targetIds.push(self.tableData.data[i].order_id);
        }
      }

      const needSelectRows = self.tableData.data.filter(
        row => targetIds.includes(row.order_id)
      );
      
      // 步骤3：逐行设置选中状态
      this.$nextTick(() => {
        needSelectRows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      });
    },
   // 全选/反选触发
    selectAll(selection) {
      console.log('selection',selection)
      var arr = [];
      for(var i=0;i<selection.length;i++){
        if(selection[i].state_text == "待派单"){
          arr.push(selection[i]);
        }
      }
      console.log('arr',arr)
      this.multipleSelection = arr;
    },

    getDriverOrder(){//获取今天订单
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      self.pageSize  = 1000;
      Params.list_rows =  self.pageSize;
      self.loading = true;
      OrderApi.getDriverOrder(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.shopList = res.data.shop_list;
          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          console.log(self)
          self.logisticsList = res.data.logistics_list;
          self.is_open_logistics = res.data.is_open_logistics
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
          self.toggleAllSelection();
        })
        .catch(error => {});
    },

    getToday(type){//获取今天订单
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.xtype = type;
      self.pageSize  = 1000;
      Params.list_rows =  self.pageSize;
      self.loading = true;
      OrderApi.todayOrderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.shopList = res.data.shop_list;
          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          console.log(self)
          self.logisticsList = res.data.logistics_list;
          self.is_open_logistics = res.data.is_open_logistics
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    closeDialogLine(e){
      let self = this;
      var line_store = e.params.line_store;
      var store_id = [];
      for(var i=0;i<line_store.length;i++){
        if(line_store[i].type == 2){
          store_id.push(line_store[i].id);
        }
      }
      OrderApi.getPeisongOrder(
              {
                store_id:JSON.stringify(store_id),    
              },
              true
            )
              .then(data => {
                  console.log(data.data)
                  self.$router.push({
                    path: '/order/order/generatedeliverynotefixedline',
                    query: {
                      order_id:JSON.stringify( data.data),
                      line_id:e.params.line_id
                    }
                  });
              })
              .catch(error => {
              });
     
      this.open_line = false;
    },
    generateDeliveryNoteByLine(){
        this.open_line = true;
    },
    selectForm(item) {
      this.order_id = item.order_id
      this.open_form = true;
    },

    /*打开编辑*/
   editClick(item) {
    console.log('item',item);
      this.order_id = item.order_id
        this.open_edit = true;
      },

    generateDeliveryNote(){
      var self = this;
      var order_id = [];
      var ind = 0;
      var indx = 0;
      for(var i=0;i<  self.multipleSelection.length;i++){
        if(self.multipleSelection[i].order_id){
          order_id.push( self.multipleSelection[i].order_id);
        }
     
        if(self.multipleSelection[i].delivery_status && (self.multipleSelection[i].delivery_status.value ==20 ||
        self.multipleSelection[i].order_status.value ==20 
        )){
          ind++;
        }
        if(self.multipleSelection[i].pay_status.value ==10 ){
          indx++;
        }
      }
      if(ind > 0){
        this.$message.error('请选择未发货/未取消的订单!');
        return;
      }
      if(indx > 0){
        this.$message.error('请选择支付订单!');
        return;
      }
      if(order_id.length > 0){
        self.$router.push({
          path: '/order/order/generatedeliverynote',
          query: {
            order_id:JSON.stringify( order_id),
            driver_id:  this.searchForm.driver_id
          }
        });
      }else{
        this.$message.error('请选择需要生成发货单的订单!');
      }
 
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.multipleSelection = val;
 
      console.log('  this.multipleSelection',  this.multipleSelection);
    },

    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            list.push(item);
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {});
    },
    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    },
    batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
        let params = this.multipleSelection;
        params.forEach((param)=>{
          console.log('param',param);
          if(param.delivery_type.value != 60){
            ids.push(param.order_id);
          }
         
        })
        ids = ids.join(',');
        // 筛选条件
        // 商品状态
        var parmasa =  this.searchForm?this.searchForm:{};

        parmasa["list_rows"] = this.pageSize
        parmasa["page"] = this.curPage
        parmasa.ids = ids
        if(ids.length > 0){
    
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(parmasa);
          
        }else{
          this.$message({
              message: '请选择要导出的数据/或者符合条件的数据',
              type: 'error'
            });
        }
    

    },
    // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else  if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getData();
        }else if (f == 'select_form') {
          this.open_form = e.openDialog;
          if (e.type == 'success') {
              this.getData(); 
          }
    }
    },
    // 显示批量发货说明
    showBatchDelivery() {
      this.dialogBatchDelivery = true;
    },
    /*跳转物流公司*/
    gotoExpress() {
      let self = this;
      self.$router.push('/setting/express/index');
    },

    /*选择图片之前*/
    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

    /*上传图片*/
    uploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append('iFile', param.file);
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close();
          self.dialogBatchDelivery = false;
          self.$message({
            message: response.msg,
            type: 'warning'
          });
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          });
          param.onError();
        });
    },

    handleCopy(text, event) {
      clip(text, event)
    },
    deleteClick(row){
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.del(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该订单删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }

  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
.unread-red{
  color: #fff;
  font-size: 10px;
  background-color: red;
  border-radius: 50%;
  display: block;
  float: right;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue